module.exports = __webpack_public_path__ + "static/media/sf-trial-1.1de37e4c.mp3";